module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://media.gettyimages.com/id/1221129797/zh/%E7%85%A7%E7%89%87/%E7%A9%BA%E5%8D%80%E6%B2%99%E6%BC%A0%E6%B2%99%E4%B8%98%E9%AD%AF%E5%B8%83%E5%93%88%E5%88%A9%E6%99%AF%E8%A7%80.jpg?s=2048x2048&w=gi&k=20&c=oMWMQli1GRlQKjhGckGhpimHI5qVdzgzLQHxeg_I3Io=',
	// bg2: 'https://5b0988e595225.cdn.sohucs.com/images/20191122/6c76c091d496443bbd26178e9332f9ee.jpeg',
	// bg3: 'https://media.istockphoto.com/id/157403457/zh/%E7%85%A7%E7%89%87/um-el-ma-oasis-mandara-lake-libyan-sahara-desert-africa.jpg?s=1024x1024&w=is&k=20&c=HdXT_je8cxrW6VKyxOSirteM8h8565JtiRw8c-21t0c=',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	// malfunctionText: '藏行狼'
}
